<template>
  <div :class="{ 'remove-cursor': !isDefaultCursor, updating: cellsStatus.updating === 'updating' }">
    <template v-if="authState">
      <router-view></router-view>
      <toasts />
    </template>
    <busy-overlay v-else :visible="true" />
  </div>
</template>

<script>
import { Auth, Hub, I18n } from "aws-amplify";
import BusyOverlay from "./components/commons/BusyOverlay.vue";
import Toasts from "./components/Toasts.vue";
import { navigateTo } from "./router";
import { CustomCursorTypes } from "./utils/constants";

export default {
  components: {
    BusyOverlay,
    Toasts,
  },
  computed: {
    authState() {
      return this.$store.state.authState;
    },
    isDefaultCursor() {
      return (
        this.$store.state.cells.arrow.activeCursor === CustomCursorTypes.Default &&
        this.$store.state.customFlow.newArrow.activeCursor === CustomCursorTypes.Default
      );
    },
    cellsStatus() {
      return this.$store.state.cells.action.status;
    },
  },
  beforeCreate() {
    const signIn = async (user) => {
      const attrs = user.attributes;
      await this.$store.dispatch("setAuthState", {
        state: "signed-in",
        user: {
          username: user.username,
          email: attrs.email,
          email_verified: attrs.email_verified,
          phone_number: attrs.phone_number,
          phone_number_verified: attrs.phone_number_verified,
        },
      });
    };

    const signOut = async () =>
      await this.$store.dispatch("setAuthState", {
        state: "signed-out",
        user: null,
      });

    this.cancelListener = Hub.listen("auth", async (data) => {
      const { payload } = data;
      const s_id = this.$route.query.awsmp_sid;

      if (s_id) {
        if (payload.event == "signUp") {
          const u_sub = payload.data.userSub;
          await this.$store.dispatch("subscription/onboard", { s_id, u_sub });
        } else if (payload.event == "signIn") {
          await signIn(payload.data);
          await this.$store.dispatch("subscription/onboard", { s_id });
          await this.$store.dispatch("subscription/load");
          navigateTo({ path: "/" });
        }
      } else if (payload.event == "signIn") {
        await signIn(payload.data);
        navigateTo({ path: "/" });
      } else if (payload.event == "signOut") {
        await signOut();
        navigateTo({ path: "/" });
      }
    });

    Auth.currentAuthenticatedUser()
      .then((user) => signIn(user))
      .catch(() => signOut());
  },
  created() {
    const userLanguage = JSON.parse(localStorage.getItem("userLanguage"));
    if (userLanguage) {
      this.$i18n.locale = userLanguage.code;
      I18n.setLanguage(userLanguage.code);
    }
  },
  beforeUnmount() {
    this.cancelListener();
  },
  methods: {},
};
</script>

<style lang="less">
@import "assets/styles/variables";
@font-face {
  font-family: "Titillium Web", sans-serif;
  src: url("https://fonts.googleapis.com/css2?family=Titillium+Web:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,300&display=swap");
}
.ps__rail-x {
  display: none;
}

/* Hide the vertical scrollbar */
.ps__rail-y {
  display: none;
}
.remove-cursor {
  cursor: none;
  pointer-events: none;
}

.updating {
  cursor: wait !important;
}
.updating * {
  cursor: wait !important;
  pointer-events: none;
}

.progress-bar {
  height: 4px;
  background-color: @kk-color-light-blue;
  width: 100%;
  overflow: hidden;
}

.progress-bar-value {
  width: 100%;
  height: 100%;
  background-color: @kk-color-primary-blue;
  animation: indeterminateAnimation 1s infinite linear;
  transform-origin: 0% 50%;
}

@keyframes indeterminateAnimation {
  0% {
    transform: translateX(0) scaleX(0);
  }
  40% {
    transform: translateX(0) scaleX(0.4);
  }
  100% {
    transform: translateX(100%) scaleX(0.5);
  }
}

&::-webkit-scrollbar {
  width: 16px;
  height: 14px;
  background: transparent;
}

&::-webkit-scrollbar-thumb {
  background: #9ebfec;
  border: 4px solid transparent;
  border-radius: 9px;
  background-clip: content-box;
}
</style>
